// Süreci tamamlanmış talepte belgeler, talebin dondurulmuş (snapshot) haliyle gösterilir
export const withSnapshot = (entity, snap) => (entity && snap
  ? { ...entity, documents: snap.documents || {}, document_files: snap.document_files || {}, approved_document_files: {}, _snapshot: true }
  : entity);

export const snapshotCompany = (permit, company) => withSnapshot(company, permit?.doc_snapshot?.company);
export const snapshotList = (permit, list, kind) => {
  const snap = permit?.doc_snapshot?.[kind];
  return snap ? list.map(e => withSnapshot(e, snap[e.id])) : list;
};
